module.exports = __webpack_public_path__ + "../resources/images/illustration_error-3d2ee0c347547019fa5b021c0c95ffb9.svg";